"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: transfer/transfer-unauthenticated-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftransfer%2Ftransfer-unauthenticated-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferUnauthenticatedServiceClient = exports.UnauthenticatedSendMoneyResponse = exports.UnauthenticatedSendMoneyRequest = exports.LookupTransferRequestResponse = exports.LookupTransferRequestRequest = exports.UnauthenticatedTransferRequestTransferUser = exports.UnauthenticatedTransferRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../common/amount");
const transfer_request_status_1 = require("../common/transfer-request-status");
const transfer_status_1 = require("./transfer-status");
const unauthed_transfer_instructions_1 = require("./unauthed-transfer-instructions");
const protobufPackage = 'com.step.transfer.proto';
function createBaseUnauthenticatedTransferRequest() {
    return {
        id: '',
        requester: exports.UnauthenticatedTransferRequestTransferUser.fromPartial({}),
        amount: amount_1.Amount.fromPartial({}),
        description: '',
        expiresAtMs: '0',
    };
}
exports.UnauthenticatedTransferRequest = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            requester: isSet(object.requester)
                ? exports.UnauthenticatedTransferRequestTransferUser.fromJSON(object.requester)
                : exports.UnauthenticatedTransferRequestTransferUser.fromPartial({}),
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            expiresAtMs: isSet(object.expiresAtMs) ? globalThis.String(object.expiresAtMs) : '0',
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.requester !== undefined) {
            obj.requester = exports.UnauthenticatedTransferRequestTransferUser.toJSON(message.requester);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        if (message.expiresAtMs !== '0') {
            obj.expiresAtMs = message.expiresAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.UnauthenticatedTransferRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnauthenticatedTransferRequest();
        message.id = object.id ?? '';
        message.requester = (object.requester !== undefined && object.requester !== null)
            ? exports.UnauthenticatedTransferRequestTransferUser.fromPartial(object.requester)
            : exports.UnauthenticatedTransferRequestTransferUser.fromPartial({});
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.description = object.description ?? '';
        message.expiresAtMs = object.expiresAtMs ?? '0';
        return message;
    },
};
function createBaseUnauthenticatedTransferRequestTransferUser() {
    return { displayName: '', pictureUrl: '' };
}
exports.UnauthenticatedTransferRequestTransferUser = {
    fromJSON(object) {
        const message = {
            displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : '',
        };
        if (isSet(object.pictureUrl)) {
            message.pictureUrl = globalThis.String(object.pictureUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.displayName !== '') {
            obj.displayName = message.displayName;
        }
        if (message.pictureUrl !== undefined && message.pictureUrl !== '') {
            obj.pictureUrl = message.pictureUrl;
        }
        return obj;
    },
    create(base) {
        return exports.UnauthenticatedTransferRequestTransferUser.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnauthenticatedTransferRequestTransferUser();
        message.displayName = object.displayName ?? '';
        message.pictureUrl = object.pictureUrl ?? '';
        return message;
    },
};
function createBaseLookupTransferRequestRequest() {
    return { transferRequestId: '' };
}
exports.LookupTransferRequestRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.transferRequestId)) {
            message.transferRequestId = globalThis.String(object.transferRequestId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transferRequestId !== undefined && message.transferRequestId !== '') {
            obj.transferRequestId = message.transferRequestId;
        }
        return obj;
    },
    create(base) {
        return exports.LookupTransferRequestRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupTransferRequestRequest();
        message.transferRequestId = object.transferRequestId ?? '';
        return message;
    },
};
function createBaseLookupTransferRequestResponse() {
    return { request: undefined, status: transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS };
}
exports.LookupTransferRequestResponse = {
    fromJSON(object) {
        const message = {
            status: isSet(object.status)
                ? (0, transfer_request_status_1.transferRequestStatusFromJSON)(object.status)
                : transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS,
        };
        if (isSet(object.request)) {
            message.request = exports.UnauthenticatedTransferRequest.fromJSON(object.request);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.request !== undefined) {
            obj.request = exports.UnauthenticatedTransferRequest.toJSON(message.request);
        }
        if (message.status !== transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS) {
            obj.status = (0, transfer_request_status_1.transferRequestStatusToJSON)(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.LookupTransferRequestResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupTransferRequestResponse();
        message.request = (object.request !== undefined && object.request !== null)
            ? exports.UnauthenticatedTransferRequest.fromPartial(object.request)
            : undefined;
        message.status = object.status ?? transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS;
        return message;
    },
};
function createBaseUnauthenticatedSendMoneyRequest() {
    return { step: unauthed_transfer_instructions_1.UnauthedTransferStep.fromPartial({}) };
}
exports.UnauthenticatedSendMoneyRequest = {
    fromJSON(object) {
        const message = {
            step: isSet(object.step)
                ? unauthed_transfer_instructions_1.UnauthedTransferStep.fromJSON(object.step)
                : unauthed_transfer_instructions_1.UnauthedTransferStep.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.step !== undefined) {
            obj.step = unauthed_transfer_instructions_1.UnauthedTransferStep.toJSON(message.step);
        }
        return obj;
    },
    create(base) {
        return exports.UnauthenticatedSendMoneyRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnauthenticatedSendMoneyRequest();
        message.step = (object.step !== undefined && object.step !== null)
            ? unauthed_transfer_instructions_1.UnauthedTransferStep.fromPartial(object.step)
            : unauthed_transfer_instructions_1.UnauthedTransferStep.fromPartial({});
        return message;
    },
};
function createBaseUnauthenticatedSendMoneyResponse() {
    return { status: transfer_status_1.TransferStatus.fromPartial({}) };
}
exports.UnauthenticatedSendMoneyResponse = {
    fromJSON(object) {
        const message = {
            status: isSet(object.status)
                ? transfer_status_1.TransferStatus.fromJSON(object.status)
                : transfer_status_1.TransferStatus.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== undefined) {
            obj.status = transfer_status_1.TransferStatus.toJSON(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.UnauthenticatedSendMoneyResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnauthenticatedSendMoneyResponse();
        message.status = (object.status !== undefined && object.status !== null)
            ? transfer_status_1.TransferStatus.fromPartial(object.status)
            : transfer_status_1.TransferStatus.fromPartial({});
        return message;
    },
};
class TransferUnauthenticatedServiceClient {
    rpc;
    name = 'com.step.transfer.proto.TransferUnauthenticatedService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/transfer';
    methods = [{
            name: 'LookupTransferRequest',
            requestType: exports.LookupTransferRequestRequest,
            responseType: exports.LookupTransferRequestResponse,
            authenticationOptions: undefined,
            adminTokenType: undefined,
        }, {
            name: 'UnauthenticatedSendMoney',
            requestType: exports.UnauthenticatedSendMoneyRequest,
            responseType: exports.UnauthenticatedSendMoneyResponse,
            authenticationOptions: undefined,
            adminTokenType: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    lookupTransferRequest(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    unauthenticatedSendMoney(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.TransferUnauthenticatedServiceClient = TransferUnauthenticatedServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=transfer-unauthenticated-service.js.map